export default __webpack_public_path__ + "static/media/538.752ac26d.png";